export const contactReportsData = [
  {
    key: "1",
    name: "Darlee Robertson",
    role: "Facility Manager",
    phone: "1234567890",
    email: "robertson@example.com",
    company: "NovaWave LLC",
    industry: "Retail Industry",
    type: "Customer",
    source: "Paid Social",
    createdDate: "25 Sep 2023, 01:22 pm",
    avatar: "assets/img/profiles/avatar-19.jpg",
    company_image: "assets/img/icons/company-icon-01.svg",
  },
  {
    key: "2",
    name: "Sharon Roy",
    role: "Installer",
    phone: "+1 989757485",
    email: "sharon@example.com",
    company: "BlueSky Industries",
    industry: "Banking",
    type: "Accounts",
    source: "Referrals",
    createdDate: "29 Sep 2023, 04:15 pm",
    avatar: "assets/img/profiles/avatar-20.jpg",
    company_image: "assets/img/icons/company-icon-02.svg",
  },
  {
    key: "3",
    name: "Vaughan",
    role: "Senior  Manager",
    phone: "+1 546555455",
    email: "vaughan12@example.com",
    company: "SilverHawk",
    industry: "Hotels",
    type: "Partner",
    source: "Campaigns",
    createdDate: "04 Oct 2023, 10:18 am",
    avatar: "assets/img/profiles/avatar-21.jpg",
    company_image: "assets/img/icons/company-icon-03.svg",
  },
  {
    key: "4",
    name: "Jessica",
    role: "Test Engineer",
    phone: "+1 454478787",
    email: "jessica13@example.com",
    company: "SummitPeak",
    industry: "Financial Services",
    type: "Prospect",
    source: "Google",
    createdDate: "17 Oct 2023, 03:31 pm",
    avatar: "assets/img/profiles/avatar-23.jpg",
    company_image: "assets/img/icons/company-icon-04.svg",
  },
  {
    key: "5",
    name: "Carol Thomas",
    role: "UI /UX Designer",
    phone: "+1 124547845",
    email: "caroltho3@example.com",
    company: "RiverStone Ventur",
    industry: "Insurance",
    type: "Lead",
    source: "Paid Social",
    createdDate: "24 Oct 2023, 09:14 pm",
    avatar: "assets/img/profiles/avatar-16.jpg",
    company_image: "assets/img/icons/company-icon-05.svg",
  },
  {
    key: "6",
    name: "Dawn Mercha",
    role: "Technician",
    phone: "+1 478845447",
    email: "dawnmercha@example.com",
    company: "Bright Bridge Grp",
    industry: "Consulatation",
    type: "Influencer",
    source: "Referrals",
    createdDate: "08 Nov 2023, 09:56 am",
    avatar: "assets/img/profiles/avatar-22.jpg",
    company_image: "assets/img/icons/company-icon-06.svg",
  },
  {
    key: "7",
    name: "Rachel Hampton",
    role: "Software Developer",
    phone: "+1 215544845",
    email: "rachel@example.com",
    company: "CoastalStar Co.",
    industry: "Agriculture",
    type: "Vendor",
    source: "Campaigns",
    createdDate: "14 Nov 2023, 04:19 pm",
    avatar: "assets/img/profiles/avatar-24.jpg",
    company_image: "assets/img/icons/company-icon-07.svg",
  },
  {
    key: "8",
    name: "Jonelle Curtiss",
    role: "Supervisor",
    phone: "+1 121145471",
    email: "jonelle@example.com",
    company: "HarborView",
    industry: "Insurance",
    type: "Customer",
    source: "Google",
    createdDate: "23 Nov 2023, 11:14 pm",
    avatar: "assets/img/profiles/avatar-25.jpg",
    company_image: "assets/img/icons/company-icon-08.svg",
  },
  {
    key: "9",
    name: "Jonathan",
    role: "Team Lead Dev",
    phone: "+1 321454789",
    email: "jonathan@example.com",
    company: "Golden Gate Ltd",
    industry: "Banking",
    type: "Accounts",
    source: "Paid Social",
    createdDate: "10 Dec 2023, 06:43 am",
    avatar: "assets/img/profiles/avatar-26.jpg",
    company_image: "assets/img/icons/company-icon-09.svg",
  },
  {
    key: "10",
    name: "Brook",
    role: "Team Lead Dev",
    phone: "+1 278907145",
    email: "brook@example.com",
    company: "Redwood Inc",
    industry: "Financial Services",
    type: "Influencer",
    source: "Referrals",
    createdDate: "25 Dec 2023, 08:17 pm",
    avatar: "assets/img/profiles/avatar-01.jpg",
    company_image: "assets/img/icons/company-icon-10.svg",
  },
];
